export default "__VITE_ASSET__CIdDFSm8__"